export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14018.cce0fdd3.jpg";